import * as React from 'react';

interface BaseDashboardProps {
  dashboard_header: React.ReactElement;
  dashboard_content: React.ReactElement;
};

export default function BaseDashboard({ dashboard_header, dashboard_content }: BaseDashboardProps) {
  return (
    <div className='sensor-dashboard'>
      {dashboard_header}

      {dashboard_content}

    </div>
  );
}

